import { createGlobalStyle, css } from 'styled-components';
import localFont from 'next/font/local';
import theme from './theme';

//! Color Generator
function colorGenerator() {
	const colorsArr = Object.keys(theme.colors);

	let colorVariable = '';

	for (let i = 0; i < colorsArr.length; i++) {
		colorVariable += `--${colorsArr[i]}: ${theme.colors[colorsArr[i]]};`;
	}

	return colorVariable;
}

//! Fonts
const montserrat_arm = localFont({
	src: [
		{
			path: '../../public/fonts/Montserratarm-Regular.ttf',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Regular.woff',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Regular.woff2',
			weight: '400',
			display: 'swap',
			style: 'normal',
		},

		{
			path: '../../public/fonts/Montserratarm-Medium.ttf',
			weight: '500',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Medium.woff',
			weight: '500',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Medium.woff2',
			weight: '500',
			display: 'swap',
			style: 'normal',
		},

		{
			path: '../../public/fonts/Montserratarm-Bold.ttf',
			weight: '600',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Bold.woff',
			weight: '600',
			display: 'swap',
			style: 'normal',
		},
		{
			path: '../../public/fonts/Montserratarm-Bold.woff2',
			weight: '600',
			display: 'swap',
			style: 'normal',
		},
	],
});

const Variables = createGlobalStyle`${css`
	:root {
		//! Fonts
		--montserrat_arm: ${montserrat_arm.style.fontFamily};

		//! Transition
		--trTime: 0.3s;

		//! Line Height
		--lineHeight: 1.4;
		--lineHeightS: 1.2;

		//! Colors
		${colorGenerator()};

		//! Grid Column Distance
		--colPadding: calc(var(--gutter) / 2);
	}

	/* //! 2560 */
	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeXL}) {
		:root {
			/* --h1: 80px; */
			--h1: 72px;
			--h2: 64px;
			--h3: 56px;
			--h4: 48px;
			--h5: 40px;
			--h6: 32px;
			--p1: 28px;
			--p2: 24px;
			--p3: 20px;
			--p4: 18px;
			--p5: 16px;
			--p6: 14px;

			//! Global Variables
			--contPaddingLR: var(--sp35x);
			--gutter: var(--sp4x);
			--sectionDistance: var(--sp24x);
			--headerFixedHeight: 124.2px;
			--headerBannerHeight: var(--sp6x);
			--burgerMenuButtonHeight: var(--sp7x);
			--burgerMenuPaddingBottom: var(--sp4x);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.desktopSizeL}) {
		:root {
			/* --h1: 64px; */
			--h1: 56px;
			--h2: 56px;
			--h3: 48px;
			--h4: 40px;
			--h5: 32px;
			--h6: 28px;
			--p1: 24px;
			--p2: 20px;
			--p3: 18px;
			--p4: 16px;
			--p5: 14px;
			--p6: 12px;

			//! Global Variables
			--contPaddingLR: var(--sp20x);
			--gutter: var(--sp3x);
			--sectionDistance: var(--sp20x);
			--headerFixedHeight: 124.2px;
			--headerBannerHeight: var(--sp5x);
			--burgerMenuButtonHeight: var(--sp6x);
			--burgerMenuPaddingBottom: var(--sp3x);
		}
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.desktopSizeM}) {
		:root {
			--h1: 56px;
			--h2: 48px;
			--h3: 40px;
			--h4: 32px;
			--h5: 28px;
			--h6: 24px;
			--p1: 20px;
			--p2: 18px;
			--p3: 16px;
			--p4: 14px;
			--p5: 14px;
			--p6: 12px;

			//! Global Variables
			--contPaddingLR: var(--sp13x);
			--gutter: var(--sp2x);
			--sectionDistance: var(--sp15x);
			--headerFixedHeight: 108.2px;
			--headerBannerHeight: var(--sp5x);
			--burgerMenuButtonHeight: var(--sp6x);
			--burgerMenuPaddingBottom: var(--sp2x);
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.desktopSizeS}) {
		:root {
			/* --h1: 48px; */
			--h1: 40px;
			--h2: 40px;
			--h3: 32px;
			--h4: 28px;
			--h5: 24px;
			--h6: 20px;
			--p1: 18px;
			--p2: 16px;
			--p3: 14px;
			--p4: 14px;
			--p5: 14px;
			--p6: 12px;

			//! Global Variables
			--contPaddingLR: var(--sp10x);
			--gutter: var(--sp2x);
			--sectionDistance: var(--sp13x);
			--headerFixedHeight: 85.95px;
			--headerBannerHeight: var(--sp4x);
			--burgerMenuButtonHeight: var(--sp6x);
			--burgerMenuPaddingBottom: var(--sp2x);
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(
			props
		) => props.theme.mediaQuery.tabletSize}) {
		:root {
			--h1: 40px;
			--h2: 32px;
			--h3: 28px;
			--h4: 24px;
			--h5: 20px;
			--h6: 18px;
			--p1: 16px;
			--p2: 16px;
			--p3: 14px;
			--p4: 14px;
			--p5: 14px;
			--p6: 12px;

			//! Global Variables
			--contPaddingLR: var(--sp8x);
			--gutter: var(--sp2x);
			--sectionDistance: var(--sp11x);
			--headerFixedHeight: 85.95px;
			--headerBannerHeight: var(--sp4x);
			--burgerMenuButtonHeight: var(--sp5x);
			--burgerMenuPaddingBottom: var(--sp2x);
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.tabletSizeS}) {
		:root {
			--h1: 32px;
			--h2: 28px;
			--h3: 24px;
			--h4: 20px;
			--h5: 18px;
			--h6: 18px;
			--p1: 14px;
			--p2: 14px;
			--p3: 14px;
			--p4: 14px;
			--p5: 14px;
			--p6: 12px;

			//! Global Variables
			--contPaddingLR: var(--sp4x);
			--gutter: var(--sp2x);
			--sectionDistance: var(--sp11x);
			--headerFixedHeight: 67.45px;
			--headerBannerHeight: var(--sp4x);
			--burgerMenuButtonHeight: var(--sp5x);
			--burgerMenuPaddingBottom: var(--sp2x);
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		:root {
			--h1: 32px;
			/* --h2: 28px; */
			--h2: 24px;
			--h3: 24px;
			--h4: 20px;
			--h5: 18px;
			--h6: 16px;
			--p1: 14px;
			--p2: 14px;
			--p3: 14px;
			--p4: 14px;
			--p5: 14px;
			--p6: 12px;

			//! Global Variables
			--contPaddingLR: var(--sp2x);
			--gutter: var(--sp1x);
			--sectionDistance: var(--sp9x);

			--headerFixedHeight: 75.83px;
			--headerBannerHeight: var(--sp5x);
			--burgerMenuButtonHeight: var(--sp5x);
			--burgerMenuPaddingBottom: var(--sp2x);
		}
	}
`}`;

export default Variables;
